export default "__VITE_ASSET__CBBk0Vd2__"